import React, { useEffect, useState } from 'react'
import { MapContainer, TileLayer, Polygon, useMapEvents, Marker, Popup } from 'react-leaflet'
import L from 'leaflet'
import axios from 'axios'
import 'leaflet/dist/leaflet.css'
const API = process.env.REACT_APP_API_URL || 'http://localhost:3001/api'

function PhIcon({ name, size=16, color="currentColor" }: any) {
  return <i className={`ph-bold ph-${name}`} style={{ fontSize:size, color, lineHeight:1 }} aria-hidden="true"/>
}

function DesenharPoligono({ ativo, onPonto }: any) {
  useMapEvents({ click(e) { if (ativo) onPonto([e.latlng.lat, e.latlng.lng]) } })
  return null
}

const FORM_VAZIO = {
  nome:'', cor:'#3B82F6', descricao:'', tipo:'permitida',
  velocidade_max:'', alertar_entrada:false, alertar_saida:true,
  bloquear_saida:false, notificar_emails:''
}

export default function Cercas() {
  const [cercas, setCercas]         = useState<any[]>([])
  const [modo, setModo]             = useState<'lista'|'novo'|'editar'>('lista')
  const [editando, setEditando]     = useState<any>(null)
  const [desenhando, setDesenhando] = useState(false)
  const [pontos, setPontos]         = useState<[number,number][]>([])
  const [form, setForm]             = useState<any>(FORM_VAZIO)
  const [clientes, setClientes]     = useState<any[]>([])
  const [clienteSel, setClienteSel] = useState('')
  const [ativos, setAtivos]         = useState<any[]>([])
  const [ativosSel, setAtivosSel]   = useState<string[]>([])
  const [salvando, setSalvando]     = useState(false)

  useEffect(() => {
    if (!document.querySelector('#phosphor-bold')) {
      const l = document.createElement('link'); l.id='phosphor-bold'; l.rel='stylesheet'
      l.href='https://unpkg.com/@phosphor-icons/web@2.1.1/src/bold/style.css'
      document.head.appendChild(l)
    }
    carregar()
  }, [])

  useEffect(() => {
    const url = clienteSel ? `${API}/ativos?cliente_id=${clienteSel}` : `${API}/ativos`
    axios.get(url).then(r => setAtivos(r.data)).catch(() => setAtivos([]))
    if (!editando) setAtivosSel([])
  }, [clienteSel])

  const carregar = async () => {
    try {
      const [c, cl] = await Promise.all([axios.get(`${API}/cercas`), axios.get(`${API}/clientes`)])
      setCercas(c.data); setClientes(cl.data)
    } catch {}
  }

  const abrirNovo = () => {
    setEditando(null); setForm(FORM_VAZIO); setPontos([]); setAtivosSel([]); setClienteSel(''); setModo('novo')
  }

  const abrirEditar = async (c: any) => {
    setEditando(c)
    setForm({
      nome: c.nome, cor: c.cor, descricao: c.descricao||'', tipo: c.tipo||'permitida',
      velocidade_max: c.velocidade_max||'', alertar_entrada: c.alertar_entrada||false,
      alertar_saida: c.alertar_saida||false, bloquear_saida: c.bloquear_saida||false,
      notificar_emails: c.notificar_emails?.join(', ')||''
    })
    const coords = c.coordenadas.map((p:any) => [p.lat, p.lng] as [number,number])
    setPontos(coords)
    setAtivosSel(c.ativos_ids?.filter(Boolean)||[])
    setModo('editar')
  }

  const salvar = async () => {
    if (pontos.length < 3) return alert('Desenhe pelo menos 3 pontos no mapa')
    if (!form.nome) return alert('Digite um nome para a cerca')
    setSalvando(true)
    try {
      const emails = form.notificar_emails
        ? form.notificar_emails.split(',').map((e:string)=>e.trim()).filter(Boolean)
        : []
      const payload = {
        ...form,
        velocidade_max: form.velocidade_max ? parseInt(form.velocidade_max) : null,
        coordenadas: pontos.map(([lat, lng]) => ({ lat, lng })),
        ativos_ids: ativosSel,
        notificar_emails: emails
      }
      if (modo === 'editar' && editando) {
        await axios.put(`${API}/cercas/${editando.id}`, payload)
      } else {
        await axios.post(`${API}/cercas`, payload)
      }
      await carregar()
      setModo('lista'); setPontos([]); setForm(FORM_VAZIO); setAtivosSel([]); setEditando(null)
    } catch (e: any) { alert(e.response?.data?.erro || 'Erro ao salvar') }
    finally { setSalvando(false) }
  }

  const excluir = async (id: string) => {
    if (!window.confirm('Excluir esta cerca?')) return
    try { await axios.delete(`${API}/cercas/${id}`); setCercas(c => c.filter(x => x.id !== id)) } catch {}
  }

  const toggleAtivo = (id: string) =>
    setAtivosSel(s => s.includes(id) ? s.filter(x => x !== id) : [...s, id])

  const centro: [number,number] = [-3.0, -47.4]

  const Toggle = ({ label, icon, value, onChange, cor='#0ea5e9' }: any) => (
    <div onClick={()=>onChange(!value)}
      style={{ display:'flex', alignItems:'center', gap:10, padding:'10px 14px',
        borderRadius:10, cursor:'pointer', border:`1px solid ${value?cor:'#2d4166'}`,
        background: value?`${cor}15`:'transparent', transition:'all 0.15s' }}>
      <div style={{ width:36, height:20, borderRadius:10, background:value?cor:'#334155',
        position:'relative', transition:'background 0.2s', flexShrink:0 }}>
        <div style={{ position:'absolute', top:2, left: value?18:2, width:16, height:16,
          borderRadius:'50%', background:'#fff', transition:'left 0.2s', boxShadow:'0 1px 3px rgba(0,0,0,0.3)' }}/>
      </div>
      <PhIcon name={icon} size={14} color={value?cor:'#64748b'}/>
      <span style={{ fontSize:12, color:value?cor:'#64748b', fontWeight:value?600:400 }}>{label}</span>
    </div>
  )

  if (modo === 'novo' || modo === 'editar') return (
    <div style={{ display:'flex', height:'100%', overflow:'hidden' }}>
      {/* Painel lateral */}
      <div style={{ width:360, background:'#111827', borderRight:'1px solid #1e2d45', display:'flex', flexDirection:'column', overflow:'hidden' }}>
        <div style={{ padding:'14px 16px', borderBottom:'1px solid #1e2d45', display:'flex', alignItems:'center', gap:8 }}>
          <button style={{ background:'none', border:'none', color:'#64748b', cursor:'pointer', padding:4 }}
            onClick={() => { setModo('lista'); setPontos([]); setEditando(null) }}>
            <PhIcon name="arrow-left" size={18} color="#64748b"/>
          </button>
          <span style={{ fontWeight:700, fontSize:15, color:'#f1f5f9' }}>
            {modo==='editar'?'Editar cerca virtual':'Nova cerca virtual'}
          </span>
        </div>

        <div style={{ flex:1, overflowY:'auto', padding:16 }}>

          {/* Dados básicos */}
          <div style={{ marginBottom:16 }}>
            <label style={{ fontSize:11, color:'#64748b', display:'block', marginBottom:4 }}>Nome da cerca *</label>
            <input value={form.nome} onChange={e=>setForm({...form,nome:e.target.value})}
              placeholder="Ex: Área do depósito"
              style={{ width:'100%', boxSizing:'border-box', padding:'9px 12px', borderRadius:8,
                border:'1px solid #2d4166', background:'#0d1b2e', color:'#f1f5f9', fontSize:12, fontFamily:'Inter' }}/>
          </div>

          {/* Tipo */}
          <div style={{ marginBottom:16 }}>
            <label style={{ fontSize:11, color:'#64748b', display:'block', marginBottom:6 }}>Tipo de cerca</label>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:8 }}>
              {[
                { id:'permitida', label:'Área Permitida', icon:'check-circle', desc:'Alertar ao SAIR', cor:'#22c55e' },
                { id:'proibida',  label:'Área Proibida',  icon:'x-circle',     desc:'Alertar ao ENTRAR', cor:'#ef4444' },
              ].map(t => (
                <div key={t.id} onClick={()=>setForm({...form,tipo:t.id})}
                  style={{ padding:'10px 12px', borderRadius:10, cursor:'pointer', textAlign:'center',
                    border:`2px solid ${form.tipo===t.id?t.cor:'#2d4166'}`,
                    background:form.tipo===t.id?`${t.cor}15`:'transparent' }}>
                  <PhIcon name={t.icon} size={20} color={form.tipo===t.id?t.cor:'#475569'}/>
                  <div style={{ fontSize:11, fontWeight:600, color:form.tipo===t.id?t.cor:'#64748b', marginTop:4 }}>{t.label}</div>
                  <div style={{ fontSize:9, color:'#475569', marginTop:2 }}>{t.desc}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Cor */}
          <div style={{ marginBottom:16 }}>
            <label style={{ fontSize:11, color:'#64748b', display:'block', marginBottom:6 }}>Cor no mapa</label>
            <div style={{ display:'flex', gap:8, alignItems:'center' }}>
              <input type="color" value={form.cor} onChange={e=>setForm({...form,cor:e.target.value})}
                style={{ width:42, height:36, padding:4, cursor:'pointer', borderRadius:8, border:'1px solid #2d4166', background:'#0d1b2e' }}/>
              <div style={{ display:'flex', gap:6 }}>
                {['#3B82F6','#22c55e','#ef4444','#f59e0b','#8b5cf6','#ec4899'].map(c => (
                  <div key={c} onClick={()=>setForm({...form,cor:c})}
                    style={{ width:26, height:26, borderRadius:6, background:c, cursor:'pointer',
                      border:form.cor===c?'3px solid white':'2px solid transparent',
                      boxShadow:form.cor===c?`0 0 0 2px ${c}`:'none' }}/>
                ))}
              </div>
            </div>
          </div>

          {/* Velocidade */}
          <div style={{ marginBottom:16, background:'#0d1b2e', borderRadius:12, padding:14, border:'1px solid #1e2d45' }}>
            <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:10 }}>
              <PhIcon name="gauge" size={15} color="#f59e0b"/>
              <span style={{ fontSize:12, fontWeight:600, color:'#f1f5f9' }}>Limite de Velocidade</span>
            </div>
            <input type="number" value={form.velocidade_max}
              onChange={e=>setForm({...form,velocidade_max:e.target.value})}
              placeholder="Ex: 30  (deixe vazio para desativar)"
              min={0} max={300}
              style={{ width:'100%', boxSizing:'border-box', padding:'8px 12px', borderRadius:8,
                border:`1px solid ${form.velocidade_max?'#f59e0b':'#2d4166'}`, background:'#111827',
                color:'#f1f5f9', fontSize:12, fontFamily:'Inter', marginBottom:8 }}/>
            <div style={{ display:'flex', gap:6 }}>
              {['20','30','40','60','80'].map(v => (
                <button key={v} onClick={()=>setForm({...form,velocidade_max:form.velocidade_max===v?'':v})}
                  style={{ flex:1, padding:'5px', borderRadius:8, cursor:'pointer', fontFamily:'Inter',
                    border:`1px solid ${form.velocidade_max===v?'#f59e0b':'#2d4166'}`,
                    background:form.velocidade_max===v?'#451a03':'transparent',
                    color:form.velocidade_max===v?'#fbbf24':'#64748b', fontSize:11 }}>
                  {v}
                </button>
              ))}
            </div>
            {form.velocidade_max && (
              <div style={{ fontSize:10, color:'#f59e0b', marginTop:8, display:'flex', alignItems:'center', gap:4 }}>
                <PhIcon name="warning" size={11} color="#f59e0b"/>
                Alerta ao ultrapassar {form.velocidade_max} km/h nesta área
              </div>
            )}
          </div>

          {/* Alertas e Ações */}
          <div style={{ marginBottom:16, background:'#0d1b2e', borderRadius:12, padding:14, border:'1px solid #1e2d45' }}>
            <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:12 }}>
              <PhIcon name="bell-ringing" size={15} color="#0ea5e9"/>
              <span style={{ fontSize:12, fontWeight:600, color:'#f1f5f9' }}>Alertas e Ações</span>
            </div>
            <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
              <Toggle label="Notificar ao entrar na área" icon="sign-in" value={form.alertar_entrada}
                onChange={(v:boolean)=>setForm({...form,alertar_entrada:v})} cor="#0ea5e9"/>
              <Toggle label="Notificar ao sair da área" icon="sign-out" value={form.alertar_saida}
                onChange={(v:boolean)=>setForm({...form,alertar_saida:v})} cor="#f59e0b"/>
              <Toggle label="Bloquear veículo ao sair" icon="lock" value={form.bloquear_saida}
                onChange={(v:boolean)=>setForm({...form,bloquear_saida:v})} cor="#ef4444"/>
            </div>
            {form.bloquear_saida && (
              <div style={{ marginTop:10, background:'#450a0a', border:'1px solid #7f1d1d',
                borderRadius:8, padding:'8px 12px', fontSize:11, color:'#fca5a5',
                display:'flex', alignItems:'center', gap:6 }}>
                <PhIcon name="warning" size={13} color="#fca5a5"/>
                Veículo será bloqueado automaticamente ao sair desta área
              </div>
            )}
          </div>

          {/* Emails extras */}
          <div style={{ marginBottom:16 }}>
            <label style={{ fontSize:11, color:'#64748b', display:'block', marginBottom:4 }}>
              <PhIcon name="envelope" size={11} color="#64748b"/> E-mails adicionais (separados por vírgula)
            </label>
            <input value={form.notificar_emails} onChange={e=>setForm({...form,notificar_emails:e.target.value})}
              placeholder="extra@email.com, outro@email.com"
              style={{ width:'100%', boxSizing:'border-box', padding:'8px 12px', borderRadius:8,
                border:'1px solid #2d4166', background:'#0d1b2e', color:'#f1f5f9', fontSize:12, fontFamily:'Inter' }}/>
          </div>

          {/* Descrição */}
          <div style={{ marginBottom:16 }}>
            <label style={{ fontSize:11, color:'#64748b', display:'block', marginBottom:4 }}>Descrição</label>
            <input value={form.descricao} onChange={e=>setForm({...form,descricao:e.target.value})}
              placeholder="Opcional"
              style={{ width:'100%', boxSizing:'border-box', padding:'8px 12px', borderRadius:8,
                border:'1px solid #2d4166', background:'#0d1b2e', color:'#f1f5f9', fontSize:12, fontFamily:'Inter' }}/>
          </div>

          {/* Desenho */}
          <div style={{ marginBottom:16, background:'#0d1b2e', borderRadius:12, padding:14, border:`1px solid ${desenhando?'#0ea5e9':'#1e2d45'}` }}>
            <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:10 }}>
              <PhIcon name="pencil-simple" size={15} color={desenhando?'#0ea5e9':'#64748b'}/>
              <span style={{ fontSize:12, fontWeight:600, color:'#f1f5f9' }}>
                {desenhando ? `Clique no mapa — ${pontos.length} ponto(s)` : 'Desenhar área no mapa'}
              </span>
            </div>
            <div style={{ display:'flex', gap:8 }}>
              <button onClick={()=>setDesenhando(d=>!d)}
                style={{ flex:1, padding:'8px', borderRadius:8, border:'none', cursor:'pointer',
                  background:desenhando?'#1e3a6e':'#0ea5e9', color:'#fff', fontSize:12, fontFamily:'Inter',
                  display:'flex', alignItems:'center', justifyContent:'center', gap:6 }}>
                <PhIcon name={desenhando?'stop-circle':'pencil'} size={14} color="#fff"/>
                {desenhando ? 'Parar desenho' : 'Iniciar desenho'}
              </button>
              {pontos.length > 0 && <>
                <button onClick={()=>setPontos(p=>p.slice(0,-1))}
                  style={{ padding:'8px 10px', borderRadius:8, border:'1px solid #2d4166',
                    background:'transparent', color:'#94a3b8', cursor:'pointer' }}>
                  <PhIcon name="arrow-counter-clockwise" size={14} color="#94a3b8"/>
                </button>
                <button onClick={()=>setPontos([])}
                  style={{ padding:'8px 10px', borderRadius:8, border:'1px solid #2d4166',
                    background:'transparent', color:'#f87171', cursor:'pointer' }}>
                  <PhIcon name="trash" size={14} color="#f87171"/>
                </button>
              </>}
            </div>
          </div>

          {/* Veículos */}
          <div style={{ background:'#0d1b2e', borderRadius:12, padding:14, border:'1px solid #1e2d45' }}>
            <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:10 }}>
              <div style={{ display:'flex', alignItems:'center', gap:8 }}>
                <PhIcon name="car" size={15} color="#0ea5e9"/>
                <span style={{ fontSize:12, fontWeight:600, color:'#f1f5f9' }}>Veículos vinculados</span>
              </div>
              <span style={{ fontSize:11, color:'#0ea5e9' }}>{ativosSel.length} selecionado(s)</span>
            </div>
            <select value={clienteSel} onChange={e=>setClienteSel(e.target.value)}
              style={{ width:'100%', padding:'7px 10px', borderRadius:8, border:'1px solid #2d4166',
                background:'#111827', color:'#f1f5f9', fontSize:11, fontFamily:'Inter', marginBottom:10 }}>
              <option value="">— Todos os clientes —</option>
              {clientes.map((c:any) => <option key={c.id} value={c.id}>{c.razao_social}</option>)}
            </select>
            <div style={{ maxHeight:180, overflowY:'auto' }}>
              {ativos.map((a:any) => (
                <div key={a.id} onClick={()=>toggleAtivo(a.id)}
                  style={{ display:'flex', alignItems:'center', gap:8, padding:'7px 0',
                    borderBottom:'1px solid rgba(45,65,102,0.3)', cursor:'pointer' }}>
                  <div style={{ width:16, height:16, borderRadius:4, flexShrink:0,
                    border:`2px solid ${ativosSel.includes(a.id)?'#0ea5e9':'#2d4166'}`,
                    background:ativosSel.includes(a.id)?'#0ea5e9':'transparent',
                    display:'flex', alignItems:'center', justifyContent:'center' }}>
                    {ativosSel.includes(a.id) && <PhIcon name="check" size={9} color="white"/>}
                  </div>
                  <div style={{ flex:1 }}>
                    <div style={{ fontSize:12, color:'#f1f5f9' }}>{a.nome}</div>
                    {a.placa && <div style={{ fontSize:10, color:'#64748b' }}>{a.placa}</div>}
                  </div>
                  <div style={{ width:7, height:7, borderRadius:'50%',
                    background:a.ignicao?'#22c55e':'#475569' }}/>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div style={{ padding:16, borderTop:'1px solid #1e2d45' }}>
          <button onClick={salvar} disabled={salvando||pontos.length<3||!form.nome}
            style={{ width:'100%', padding:'12px', borderRadius:12, border:'none',
              background:salvando||pontos.length<3||!form.nome?'#1e2d45':'#0ea5e9',
              color:'#fff', cursor:salvando||pontos.length<3||!form.nome?'not-allowed':'pointer',
              fontSize:14, fontWeight:700, fontFamily:'Inter',
              display:'flex', alignItems:'center', justifyContent:'center', gap:8 }}>
            <PhIcon name={salvando?'circle-notch':'floppy-disk'} size={16} color="#fff"/>
            {salvando ? 'Salvando...' : modo==='editar' ? 'Salvar alterações' : `Criar cerca (${pontos.length} pts)`}
          </button>
        </div>
      </div>

      {/* Mapa */}
      <div style={{ flex:1 }}>
        <MapContainer center={centro} zoom={5} style={{ width:'100%', height:'100%' }}>
          <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"/>
          <DesenharPoligono ativo={desenhando} onPonto={(p:any)=>setPontos(prev=>[...prev,p])}/>
          {pontos.length >= 3 && <Polygon positions={pontos} pathOptions={{ color:form.cor, fillOpacity:0.2, weight:2.5 }}/>}
          {pontos.map((p,i) => (
            <Marker key={i} position={p}
              icon={L.divIcon({ html:`<div style="background:${form.cor};width:12px;height:12px;border-radius:50%;border:2px solid white;box-shadow:0 1px 4px rgba(0,0,0,0.4)"></div>`, className:'', iconSize:[12,12], iconAnchor:[6,6] })}>
              <Popup>Ponto {i+1}</Popup>
            </Marker>
          ))}
          {cercas.filter(c=>c.id!==editando?.id).map((c:any) => (
            <Polygon key={c.id} positions={c.coordenadas.map((p:any)=>[p.lat,p.lng])}
              pathOptions={{ color:c.cor, fillOpacity:0.1, weight:1.5, dashArray:'6,4' }}/>
          ))}
        </MapContainer>
      </div>
    </div>
  )

  return (
    <div style={{ padding:24, overflowY:'auto', height:'100%', background:'#0d1117' }}>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:24 }}>
        <div>
          <h2 style={{ fontSize:20, fontWeight:700, color:'#f1f5f9', margin:0, display:'flex', alignItems:'center', gap:10 }}>
            <PhIcon name="polygon" size={22} color="#0ea5e9"/> Cercas Virtuais
          </h2>
          <p style={{ fontSize:12, color:'#64748b', marginTop:4 }}>{cercas.length} cerca(s) cadastrada(s)</p>
        </div>
        <button onClick={abrirNovo}
          style={{ padding:'9px 18px', borderRadius:10, border:'none', background:'#0ea5e9',
            color:'#fff', cursor:'pointer', fontSize:13, fontWeight:600, fontFamily:'Inter',
            display:'flex', alignItems:'center', gap:8 }}>
          <PhIcon name="plus" size={15} color="#fff"/> Nova cerca
        </button>
      </div>

      {cercas.length === 0 ? (
        <div style={{ background:'#111827', border:'1px solid #1e2d45', borderRadius:14, textAlign:'center', padding:48 }}>
          <PhIcon name="polygon" size={48} color="#1e2d45"/>
          <div style={{ fontSize:16, fontWeight:600, marginBottom:8, color:'#f1f5f9', marginTop:16 }}>Nenhuma cerca cadastrada</div>
          <div style={{ fontSize:13, color:'#64748b', marginBottom:20 }}>
            Crie cercas para monitorar entradas, saídas, velocidade e bloqueios automáticos
          </div>
          <button onClick={abrirNovo}
            style={{ padding:'10px 24px', borderRadius:10, border:'none', background:'#0ea5e9',
              color:'#fff', cursor:'pointer', fontSize:13, fontWeight:600, fontFamily:'Inter' }}>
            Criar primeira cerca
          </button>
        </div>
      ) : (
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(320px,1fr))', gap:16 }}>
          {cercas.map((c:any) => (
            <div key={c.id} style={{ background:'#111827', border:'1px solid #1e2d45', borderRadius:14, padding:18 }}>
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:12 }}>
                <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                  <div style={{ width:14, height:14, borderRadius:3, background:c.cor, flexShrink:0 }}/>
                  <div style={{ fontWeight:700, fontSize:14, color:'#f1f5f9' }}>{c.nome}</div>
                </div>
                <div style={{ display:'flex', gap:6, alignItems:'center' }}>
                  <span style={{ fontSize:10, padding:'2px 8px', borderRadius:10,
                    background:c.tipo==='proibida'?'#450a0a':'#14532d',
                    border:`1px solid ${c.tipo==='proibida'?'#ef4444':'#22c55e'}`,
                    color:c.tipo==='proibida'?'#f87171':'#4ade80' }}>
                    {c.tipo==='proibida'?'Proibida':'Permitida'}
                  </span>
                  <span style={{ fontSize:10, padding:'2px 8px', borderRadius:10,
                    background:c.ativa?'#0c2a4a':'#1e293b',
                    border:`1px solid ${c.ativa?'#0ea5e9':'#334155'}`,
                    color:c.ativa?'#38bdf8':'#64748b' }}>
                    {c.ativa?'Ativa':'Inativa'}
                  </span>
                </div>
              </div>

              {/* Configs ativas */}
              <div style={{ display:'flex', flexWrap:'wrap', gap:6, marginBottom:12 }}>
                {c.velocidade_max && (
                  <span style={{ fontSize:10, padding:'2px 8px', borderRadius:10,
                    background:'#451a03', border:'1px solid #f59e0b', color:'#fbbf24',
                    display:'flex', alignItems:'center', gap:4 }}>
                    <PhIcon name="gauge" size={10} color="#fbbf24"/>{c.velocidade_max} km/h
                  </span>
                )}
                {c.alertar_entrada && (
                  <span style={{ fontSize:10, padding:'2px 8px', borderRadius:10,
                    background:'#0c2a4a', border:'1px solid #0ea5e9', color:'#38bdf8',
                    display:'flex', alignItems:'center', gap:4 }}>
                    <PhIcon name="sign-in" size={10} color="#38bdf8"/>Alerta entrada
                  </span>
                )}
                {c.alertar_saida && (
                  <span style={{ fontSize:10, padding:'2px 8px', borderRadius:10,
                    background:'#0c2a4a', border:'1px solid #0ea5e9', color:'#38bdf8',
                    display:'flex', alignItems:'center', gap:4 }}>
                    <PhIcon name="sign-out" size={10} color="#38bdf8"/>Alerta saída
                  </span>
                )}
                {c.bloquear_saida && (
                  <span style={{ fontSize:10, padding:'2px 8px', borderRadius:10,
                    background:'#450a0a', border:'1px solid #ef4444', color:'#f87171',
                    display:'flex', alignItems:'center', gap:4 }}>
                    <PhIcon name="lock" size={10} color="#f87171"/>Bloquear ao sair
                  </span>
                )}
              </div>

              {c.descricao && (
                <div style={{ fontSize:12, color:'#64748b', marginBottom:10 }}>{c.descricao}</div>
              )}

              <div style={{ fontSize:11, color:'#475569', marginBottom:14, display:'flex', gap:12 }}>
                <span style={{ display:'flex', alignItems:'center', gap:4 }}>
                  <PhIcon name="map-pin" size={11} color="#475569"/>{c.coordenadas?.length||0} pontos
                </span>
                <span style={{ display:'flex', alignItems:'center', gap:4 }}>
                  <PhIcon name="car" size={11} color="#475569"/>{c.ativos_ids?.filter(Boolean).length||0} veículos
                </span>
                <span>{new Date(c.criado_em).toLocaleDateString('pt-BR')}</span>
              </div>

              <div style={{ display:'flex', gap:8 }}>
                <button onClick={()=>abrirEditar(c)}
                  style={{ flex:1, padding:'8px', borderRadius:8, border:'1px solid #2d4166',
                    background:'transparent', color:'#94a3b8', cursor:'pointer', fontSize:12,
                    fontFamily:'Inter', display:'flex', alignItems:'center', justifyContent:'center', gap:6 }}>
                  <PhIcon name="pencil-simple" size={13} color="#94a3b8"/>Editar
                </button>
                <button onClick={()=>excluir(c.id)}
                  style={{ padding:'8px 12px', borderRadius:8, border:'1px solid #7f1d1d',
                    background:'transparent', color:'#f87171', cursor:'pointer' }}>
                  <PhIcon name="trash" size={14} color="#f87171"/>
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
